<template>
    <b-modal size="lg" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="prefix + title">
        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">
                    <b-form-row class="mt-2">
                        <lg-form-textarea description=" " label="Justificativa:" cols="12"
                            v-model="form.justificativa" />
                    </b-form-row>
                </b-card>
            </b-card-body>
        </b-card>
        <b-form-row class="mt-2">
            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
                <b-button id="salvarBaixaItemBemConsumoEstorno" class="my-2" size="sm" pill variant="success"
                    @click="save">
                    <b-icon icon="check-circle" />
                    <b-tooltip :target="'salvarBaixaItemBemConsumoEstorno'" title="Salvar"></b-tooltip>
                </b-button>
                <b-button id="cancelarBaixaItemBemConsumoEstorno" class="my-2 ml-2" size="sm" pill variant="danger"
                    @click="cancelar">
                    <b-icon icon="x-circle" />
                    <b-tooltip :target="'cancelarBaixaItemBemConsumoEstorno'" title="Cancelar"></b-tooltip>
                </b-button>
            </b-col>
            <b-col cols="3"></b-col>
        </b-form-row>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFormTextarea from "@/core/components/Form/LgFormTextarea.vue";
import { BButton, BCard, BCardBody, BFormRow, BCol, BIcon, BTooltip } from "bootstrap-vue";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
    name: "BaixaItemBemConsumoEstornoForm",
    components: {
        LgFormTextarea,
        BButton,
        BCard,
        BCardBody,
        BFormRow,
        BCol,
        BIcon,
        BTooltip
    },
    props: {
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Justificativa Estorno Item Bem Consumo"
        },
        id: {
            type: Number,
            default: null
        },
        quantidade: {
            type: Number,
            default: null
        },
        isIndividual: {
            type: Boolean,
            defualt: false
        }
    },
    mixins: [FormResourceMixin],
    data() {
        return {
            form: {
                justificativa: "",
            },
            loading: false,
            savedId: this.id,
            showModal: true
        };
    },
    async beforeMount() {
        this.$service = new ResourceService("/api/baixaitembemconsumo");
    },
    methods: {
        cancelar() {
            this.$emit("close");
        },
        closemodal() {
            this.showItens = false;
        },
        async save() {
            this.loading = true;
            try {
                if (!this.isIndividual) {
                    const payload = {
                        justificativa: this.form.justificativa
                    };
                    await this.$service.post("estorno-baixa-ibc/" + this.id, payload);
                    this.$notify({
                        type: "success",
                        message: "Itens da baixa estornados com sucesso!"
                    });
                    this.loading = false;
                    this.$emit("close");
                } else {
                    const payload = {
                        justificativa: this.form.justificativa,
                        quantidade: this.quantidade
                    };
                    await this.$service.post("estorno-individual-ibc/" + this.id, payload);
                    this.$notify({
                        type: "success",
                        message: "Itens da baixa estornados com sucesso!"
                    });
                    this.loading = false;
                    this.$emit("close");
                }
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data
                });
            }
        },
    }
};
</script>

<style scoped></style>
